var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";

var style = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: 0,
  overflow: "hidden",
  position: "absolute"
};

export default (function (props) {
  return React.createElement("div", _extends({ style: style }, props));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reach/visually-hidden/es/index.js
// module id = 454
// module chunks = 0